export interface DictonaryEntry {
  Key: string;
  Language: string;
  Phrase: string;
}

export interface DictionaryFeature {
  Name: string;
  Entries: DictonaryEntry[];
}

export interface DictionaryGlobal {
  Features: DictionaryFeature[];
  getFeature: (feature: string) => DictionaryFeature;
  getEntry: (feature: string, key: string, language: string) => DictonaryEntry;
  getPhrase: (feature: string, key: string, language: string) => string;
}

export class DictionaryGlobalClass implements DictionaryGlobal {
  Features: DictionaryFeature[];
  getFeature(feature: string): DictionaryFeature {
    const featureLower = feature.toLowerCase();
    const featureFound = this.Features.filter((Feature) => Feature.Name.toLowerCase() === featureLower);
    if (featureFound.length > 0) {
      return featureFound[0];
    }
    return null;
  }
  getEntry(feature: string, key: string, language: string): DictonaryEntry {
    const featureFound = this.getFeature(feature);
    if (featureFound) {
      const keyLower = key.toLowerCase();
      const lowerLanguage = language.toLowerCase();
      const entryFound = featureFound.Entries.filter((Entry) => Entry.Key.toLowerCase() === keyLower && Entry.Language.toLowerCase() === lowerLanguage);
      if (entryFound && entryFound.length > 0) {
        return entryFound[0];
      }
    }
    return null;
  }

  getPhrase(feature: string, key: string, language: string): string {
    const entryFound = this.getEntry(feature, key, language);
    if (entryFound) {
      return entryFound.Phrase;
    }
    return null;
  }
  /* eslint-disable @typescript-eslint/no-explicit-any, @typescript-eslint/no-unsafe-member-access, @typescript-eslint/no-unsafe-assignment */
  constructor(initObect: any) {
    if (initObect?.Features) {
      this.Features = initObect.Features;
    } else {
      this.Features = [];
    }
  }
  /* eslint-enable @typescript-eslint/no-explicit-any, @typescript-eslint/no-unsafe-member-access, @typescript-eslint/no-unsafe-assignment */
}
